import React from 'react';
import UnitFormatService from '../../../RealEstate/services/UnitFormatService';
import RealEstateResult from './RealEstateResult';
const UnitResult = ({ hit }) => {
    var _a, _b;
    const unit = hit._source.fields;
    const price = UnitFormatService.getPrice(unit);
    const content = [unit.postal_code, (_a = unit.city) === null || _a === void 0 ? void 0 : _a.toUpperCase(), (_b = unit.quarter) === null || _b === void 0 ? void 0 : _b.toUpperCase()]
        .filter(Boolean)
        .join(' - ');
    return (React.createElement(RealEstateResult, { hit: hit, imageUrl: unit.list_image, title: unit.name, content: React.createElement(React.Fragment, null,
            content,
            React.createElement("div", null, unit.house_type),
            React.createElement("div", { className: "sm:zds-hidden zds-margin-top-3 zds-bold zds-truncate search-list-unit-price" }, price)), contentEnd: price }));
};
export default UnitResult;
